import { Injectable } from '@angular/core';
import { GenericHttpService } from '../generic.http.service';
import { AppConfig } from '../../../config';
import { HttpClient } from '@angular/common/http';
import { EmailManager } from '../../../model/api/administration/email-manager';
import { EmailManagerReason } from '../../../model/api/common/email-manager-reason';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class EmailManagerHttpService extends GenericHttpService<EmailManager, number> {
    constructor(public http: HttpClient) {
        super(http, "", "emailmanagers");
    }

    addNewReason(email: EmailManagerReason): Observable<EmailManagerReason> {
        let url: string = AppConfig.urlPrefix + this.url + '/declined';

        return this.http.post(url, JSON.stringify(email), { headers: this.headers }).pipe(
            map((data: any) => {
                return data;
            }));
    }

    public accept(Id: number): Observable<any> {
      return this.http.post(AppConfig.urlPrefix + this.url + `/accept/ ${Id}`,
          { headers: this.headers }).pipe(
          map((data: Response) => {
              return data;
          }));
  }

  public decline(Id: number): Observable<any> {
    return this.http.post(AppConfig.urlPrefix + this.url + `/decline/ ${Id}`,
        { headers: this.headers }).pipe(
        map((data: Response) => {
            return data;
        }));
}

}
